/**
 * Use Case: Fetch E-Wallet Providers
 * Business logic for fetching the list of available E-Wallet providers.
 */

import type { EWalletProvider } from "../model/RewardCatalogModel";
import type { IRewardCatalogRepository } from "../repository/IRewardCatalogRepository";
import { rewardCatalogContainer, TYPES } from "../../di/RewardCatalogModule";

/**
 * Fetch the list of available E-Wallet providers
 */
export const FetchEWalletProvidersUseCase = async (): Promise<
  readonly EWalletProvider[]
> => {
  const repository = rewardCatalogContainer.get<IRewardCatalogRepository>(
    TYPES.IRewardCatalogRepository
  );
  return repository.fetchEWalletProviders();
};

